/* formValidatorTranslations.js */
export const formvalidator_translations = {
    nl: {
        required: 'Dit veld is verplicht in te vullen',
        requiredSelect: 'Selecteer een optie',
        requiredCheckbox: 'Dit veld is verplicht in te vullen',
        requiredCheckboxgroup: 'Selecteer minstens &eacute;&eacute;n optie',
        requiredRadiogroup: 'Selecteer een optie',
        password: 'Moet 1 hoofdletter, 1 cijfer en 1 symbool bevatten',
        minlength: 'Dit veld moet minimaal %1$s karakters bevatten',
        maxlength: 'Dit veld mag maximaal %1$s karakters bevatten',
        email: 'Gelieve een geldig e-mailadres in te voeren',
        tel: 'Dit is geen geldig telefoonnummer (bv.: +3232987651)',
        min: 'Het getal moet %1 of groter zijn',
        max: 'Het getal moet %1 of kleiner zijn',
    },

    fr: {
        required: 'Ce champ est obligatoire',
        requiredSelect: 'Sélectionnez une option',
        requiredCheckbox: 'Ce champ est obligatoire',
        requiredCheckboxgroup: 'Sélectionnez au moins une option',
        requiredRadiogroup: 'Sélectionnez une option',
        password: 'Doit avoir 1 lettre minuscule et majuscule, 1 chiffre et 1 symbole',
        minlength: 'Ce champ doit comporter %1$s caractères',
        maxlength: 'Ce champ peut comporter %1$s caractères',
        email: 'Cette adresse e-mail n\'est pas valide',
        tel: 'Ce numéro de téléphone n\'est pas correct (par exemple: +3232987651)',
        min: 'Le nombre doit être %1 ou plus',
        max: 'Le nombre doit être % 1 ou moins',
    },

    en: {
        required: 'This field is mandatory',
        requiredSelect: 'Select an option',
        requiredCheckbox: 'This field is mandatory',
        requiredCheckboxgroup: 'Select at least one option',
        requiredRadiogroup: 'Select an option',
        password: 'Must have 1 lower- and uppercase letter, 1 number and 1 symbol',
        minlength: 'This field need to contain at least %1$s characters',
        maxlength: 'This field can contain at most %1$s characters',
        email: 'This is not a valid email address',
        tel: 'This is not a valid phone number (e.g. +3232987651)',
        min: 'This value must be higher than %1',
        max: 'This value must be less than %1',
    },
};

export const password_strength_translations = {
    nl_be: {
        tooShort: 'Te kort',
        veryWeak: 'Zeer zwak',
        weak: 'Zwak',
        good: 'Ok, kan beter',
        strong: 'Sterk',
        veryStrong: 'Zeer sterk',
    },

    en_us: {
        tooShort: 'Too short',
        veryWeak: 'Very weak',
        weak: 'Weak',
        good: 'Goodr',
        strong: 'Strong',
        veryStrong: 'Very strong',
    },
};
